module.exports = __webpack_public_path__ + "static/media/LI2.4c418095.jpg";